import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
export default {
    getTotalPrepressReports(_, query) {       
        return axios
            .get(`/prepress-reports/total-plates-report?${query}`)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie ilości płyt wykonanych nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getAdditionalPlatesPrepressReports({ commit }, {query, userEmail}) {
        return axios
            .get(`/plate-orders/plate-order-items?${query}`)
            .then(response => {
                if (userEmail) {
                    commit('SHOW_NOTIFICATION', {
                        type: 'success',
                        message: `Raport został wysłany na adres ${userEmail}.`
                    }, { root: true })
                }

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych raportu płyt dodatkowych nie powiodło się.')

                return Promise.reject(error)
            })

    },
    generateExcelReport({ commit }, {query, userEmail}) {
        return axios
            .post(`/prepress-reports/plate-excel-report?${query}`)
            .then(response => {
                if (userEmail) {
                    commit('SHOW_NOTIFICATION', {
                        type: 'success',
                        message: `Raport został wysłany na adres ${userEmail}.`
                    }, { root: true })
                }

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Generowanie raportu Excel nie powiodło się.')

                return Promise.reject(error)
            })
    }

}